module.exports = __webpack_public_path__ + "img/how-to-3.98857fb7.png";